/**
 * Fallback snapshot used when the API cannot be reached so the Store OS shell
 * still renders meaningful placeholder figures instead of an empty screen.
 */
import type { DashboardView } from '../types/api'

export const MOCK_DASHBOARD: DashboardView = {
  storeLabel: 'Eindhoven - Markt',
  storeCode: 'NL-104',
  storeOpen: true,
  liveSplh: 104.5,
  targetSplh: 105,
  activeClockins: 6,
  scheduledShifts: 11,
  prepCompletedPans: 14,
  prepTotalPans: 19,
  prepCompletionPct: 72,
  pendingProcurementOrders: 3,
  unreadReviews: 12,
  currency: 'EUR',
  generatedAt: new Date().toISOString(),
  modules: [
    {
      key: 'prep_sheets',
      label: 'Dynamic Prep Sheets',
      source_system: 'Horeko',
      status: 'beta',
    },
    {
      key: 'shift_roster',
      label: 'Shift Roster & Clock-ins',
      source_system: 'Shiftbase',
      status: 'beta',
    },
    {
      key: 'procurement',
      label: 'Supplier Procurement',
      source_system: 'Bidfood / Van Gelder',
      status: 'planned',
    },
    {
      key: 'reviews_feed',
      label: 'Reviews & Delivery Feed',
      source_system: 'Uber Eats / Google / Thuisbezorgd',
      status: 'planned',
    },
  ],
  isLive: false,
}
